import { B as Rn } from "./base-CMhGIFuX.mjs.js";
import { r as rt, P as z, c as Et, u as Tn, a as Ot, b as ne, d as En, e as ht, f as st, g as On, h as $, i as In, j as Nn, k as _n, l as Mn, R as Dn, F as jn, D as Ln, m as gt, C as It, n as kn, q as Vn } from "./Combination-B901nBpt.mjs.js";
import { r as h, j as w, c as Hn } from "./client-BkmPNNjT.mjs.js";
import { u as G, c as Bn, a as ye } from "./utils-DrJAg__I.mjs.js";
import { c as Fn } from "./createLucideIcon-DSKUQ9gX.mjs.js";
const Wn = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], $n = Fn("chevron-up", Wn), zn = ["top", "right", "bottom", "left"], le = Math.min, q = Math.max, Me = Math.round, Ne = Math.floor, te = (e) => ({
  x: e,
  y: e
}), Un = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Kn = {
  start: "end",
  end: "start"
};
function Ge(e, t, n) {
  return q(e, le(t, n));
}
function se(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ie(e) {
  return e.split("-")[0];
}
function be(e) {
  return e.split("-")[1];
}
function it(e) {
  return e === "x" ? "y" : "x";
}
function ct(e) {
  return e === "y" ? "height" : "width";
}
const qn = /* @__PURE__ */ new Set(["top", "bottom"]);
function ee(e) {
  return qn.has(ie(e)) ? "y" : "x";
}
function lt(e) {
  return it(ee(e));
}
function Yn(e, t, n) {
  n === void 0 && (n = !1);
  const o = be(e), r = lt(e), i = ct(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = De(s)), [s, De(s)];
}
function Xn(e) {
  const t = De(e);
  return [Ze(e), t, Ze(t)];
}
function Ze(e) {
  return e.replace(/start|end/g, (t) => Kn[t]);
}
const xt = ["left", "right"], wt = ["right", "left"], Gn = ["top", "bottom"], Zn = ["bottom", "top"];
function Jn(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? wt : xt : t ? xt : wt;
    case "left":
    case "right":
      return t ? Gn : Zn;
    default:
      return [];
  }
}
function Qn(e, t, n, o) {
  const r = be(e);
  let i = Jn(ie(e), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), t && (i = i.concat(i.map(Ze)))), i;
}
function De(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Un[t]);
}
function eo(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Nt(e) {
  return typeof e != "number" ? eo(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function je(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function vt(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const i = ee(t), s = lt(t), c = ct(s), l = ie(t), d = i === "y", a = o.x + o.width / 2 - r.width / 2, f = o.y + o.height / 2 - r.height / 2, g = o[c] / 2 - r[c] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: a,
        y: o.y - r.height
      };
      break;
    case "bottom":
      m = {
        x: a,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (be(t)) {
    case "start":
      m[s] -= g * (n && d ? -1 : 1);
      break;
    case "end":
      m[s] += g * (n && d ? -1 : 1);
      break;
  }
  return m;
}
const to = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let d = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: a,
    y: f
  } = vt(d, o, l), g = o, m = {}, p = 0;
  for (let u = 0; u < c.length; u++) {
    const {
      name: x,
      fn: y
    } = c[u], {
      x: v,
      y: S,
      data: C,
      reset: b
    } = await y({
      x: a,
      y: f,
      initialPlacement: o,
      placement: g,
      strategy: r,
      middlewareData: m,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    a = v ?? a, f = S ?? f, m = {
      ...m,
      [x]: {
        ...m[x],
        ...C
      }
    }, b && p <= 50 && (p++, typeof b == "object" && (b.placement && (g = b.placement), b.rects && (d = b.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : b.rects), {
      x: a,
      y: f
    } = vt(d, g, l)), u = -1);
  }
  return {
    x: a,
    y: f,
    placement: g,
    strategy: r,
    middlewareData: m
  };
};
async function Ee(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: c,
    strategy: l
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: a = "viewport",
    elementContext: f = "floating",
    altBoundary: g = !1,
    padding: m = 0
  } = se(t, e), p = Nt(m), x = c[g ? f === "floating" ? "reference" : "floating" : f], y = je(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: d,
    rootBoundary: a,
    strategy: l
  })), v = f === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), C = await (i.isElement == null ? void 0 : i.isElement(S)) ? await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = je(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: v,
    offsetParent: S,
    strategy: l
  }) : v);
  return {
    top: (y.top - b.top + p.top) / C.y,
    bottom: (b.bottom - y.bottom + p.bottom) / C.y,
    left: (y.left - b.left + p.left) / C.x,
    right: (b.right - y.right + p.right) / C.x
  };
}
const no = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: l
    } = t, {
      element: d,
      padding: a = 0
    } = se(e, t) || {};
    if (d == null)
      return {};
    const f = Nt(a), g = {
      x: n,
      y: o
    }, m = lt(r), p = ct(m), u = await s.getDimensions(d), x = m === "y", y = x ? "top" : "left", v = x ? "bottom" : "right", S = x ? "clientHeight" : "clientWidth", C = i.reference[p] + i.reference[m] - g[m] - i.floating[p], b = g[m] - i.reference[m], O = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(d));
    let R = O ? O[S] : 0;
    (!R || !await (s.isElement == null ? void 0 : s.isElement(O))) && (R = c.floating[S] || i.floating[p]);
    const N = C / 2 - b / 2, H = R / 2 - u[p] / 2 - 1, M = le(f[y], H), D = le(f[v], H), j = M, _ = R - u[p] - D, E = R / 2 - u[p] / 2 + N, B = Ge(j, E, _), T = !l.arrow && be(r) != null && E !== B && i.reference[p] / 2 - (E < j ? M : D) - u[p] / 2 < 0, I = T ? E < j ? E - j : E - _ : 0;
    return {
      [m]: g[m] + I,
      data: {
        [m]: B,
        centerOffset: E - B - I,
        ...T && {
          alignmentOffset: I
        }
      },
      reset: T
    };
  }
}), oo = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: l,
        elements: d
      } = t, {
        mainAxis: a = !0,
        crossAxis: f = !0,
        fallbackPlacements: g,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: u = !0,
        ...x
      } = se(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = ie(r), v = ee(c), S = ie(c) === c, C = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), b = g || (S || !u ? [De(c)] : Xn(c)), O = p !== "none";
      !g && O && b.push(...Qn(c, u, p, C));
      const R = [c, ...b], N = await Ee(t, x), H = [];
      let M = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (a && H.push(N[y]), f) {
        const E = Yn(r, s, C);
        H.push(N[E[0]], N[E[1]]);
      }
      if (M = [...M, {
        placement: r,
        overflows: H
      }], !H.every((E) => E <= 0)) {
        var D, j;
        const E = (((D = i.flip) == null ? void 0 : D.index) || 0) + 1, B = R[E];
        if (B && (!(f === "alignment" ? v !== ee(B) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        M.every((A) => ee(A.placement) === v ? A.overflows[0] > 0 : !0)))
          return {
            data: {
              index: E,
              overflows: M
            },
            reset: {
              placement: B
            }
          };
        let T = (j = M.filter((I) => I.overflows[0] <= 0).sort((I, A) => I.overflows[1] - A.overflows[1])[0]) == null ? void 0 : j.placement;
        if (!T)
          switch (m) {
            case "bestFit": {
              var _;
              const I = (_ = M.filter((A) => {
                if (O) {
                  const L = ee(A.placement);
                  return L === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  L === "y";
                }
                return !0;
              }).map((A) => [A.placement, A.overflows.filter((L) => L > 0).reduce((L, K) => L + K, 0)]).sort((A, L) => A[1] - L[1])[0]) == null ? void 0 : _[0];
              I && (T = I);
              break;
            }
            case "initialPlacement":
              T = c;
              break;
          }
        if (r !== T)
          return {
            reset: {
              placement: T
            }
          };
      }
      return {};
    }
  };
};
function yt(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function St(e) {
  return zn.some((t) => e[t] >= 0);
}
const ro = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = se(e, t);
      switch (o) {
        case "referenceHidden": {
          const i = await Ee(t, {
            ...r,
            elementContext: "reference"
          }), s = yt(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: St(s)
            }
          };
        }
        case "escaped": {
          const i = await Ee(t, {
            ...r,
            altBoundary: !0
          }), s = yt(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: St(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, _t = /* @__PURE__ */ new Set(["left", "top"]);
async function so(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = ie(n), c = be(n), l = ee(n) === "y", d = _t.has(s) ? -1 : 1, a = i && l ? -1 : 1, f = se(t, e);
  let {
    mainAxis: g,
    crossAxis: m,
    alignmentAxis: p
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return c && typeof p == "number" && (m = c === "end" ? p * -1 : p), l ? {
    x: m * a,
    y: g * d
  } : {
    x: g * d,
    y: m * a
  };
}
const io = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: c
      } = t, l = await so(t, e);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, co = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (x) => {
            let {
              x: y,
              y: v
            } = x;
            return {
              x: y,
              y: v
            };
          }
        },
        ...l
      } = se(e, t), d = {
        x: n,
        y: o
      }, a = await Ee(t, l), f = ee(ie(r)), g = it(f);
      let m = d[g], p = d[f];
      if (i) {
        const x = g === "y" ? "top" : "left", y = g === "y" ? "bottom" : "right", v = m + a[x], S = m - a[y];
        m = Ge(v, m, S);
      }
      if (s) {
        const x = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", v = p + a[x], S = p - a[y];
        p = Ge(v, p, S);
      }
      const u = c.fn({
        ...t,
        [g]: m,
        [f]: p
      });
      return {
        ...u,
        data: {
          x: u.x - n,
          y: u.y - o,
          enabled: {
            [g]: i,
            [f]: s
          }
        }
      };
    }
  };
}, lo = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: i,
        middlewareData: s
      } = t, {
        offset: c = 0,
        mainAxis: l = !0,
        crossAxis: d = !0
      } = se(e, t), a = {
        x: n,
        y: o
      }, f = ee(r), g = it(f);
      let m = a[g], p = a[f];
      const u = se(c, t), x = typeof u == "number" ? {
        mainAxis: u,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...u
      };
      if (l) {
        const S = g === "y" ? "height" : "width", C = i.reference[g] - i.floating[S] + x.mainAxis, b = i.reference[g] + i.reference[S] - x.mainAxis;
        m < C ? m = C : m > b && (m = b);
      }
      if (d) {
        var y, v;
        const S = g === "y" ? "width" : "height", C = _t.has(ie(r)), b = i.reference[f] - i.floating[S] + (C && ((y = s.offset) == null ? void 0 : y[f]) || 0) + (C ? 0 : x.crossAxis), O = i.reference[f] + i.reference[S] + (C ? 0 : ((v = s.offset) == null ? void 0 : v[f]) || 0) - (C ? x.crossAxis : 0);
        p < b ? p = b : p > O && (p = O);
      }
      return {
        [g]: m,
        [f]: p
      };
    }
  };
}, ao = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: i,
        platform: s,
        elements: c
      } = t, {
        apply: l = () => {
        },
        ...d
      } = se(e, t), a = await Ee(t, d), f = ie(r), g = be(r), m = ee(r) === "y", {
        width: p,
        height: u
      } = i.floating;
      let x, y;
      f === "top" || f === "bottom" ? (x = f, y = g === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (y = f, x = g === "end" ? "top" : "bottom");
      const v = u - a.top - a.bottom, S = p - a.left - a.right, C = le(u - a[x], v), b = le(p - a[y], S), O = !t.middlewareData.shift;
      let R = C, N = b;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (N = S), (o = t.middlewareData.shift) != null && o.enabled.y && (R = v), O && !g) {
        const M = q(a.left, 0), D = q(a.right, 0), j = q(a.top, 0), _ = q(a.bottom, 0);
        m ? N = p - 2 * (M !== 0 || D !== 0 ? M + D : q(a.left, a.right)) : R = u - 2 * (j !== 0 || _ !== 0 ? j + _ : q(a.top, a.bottom));
      }
      await l({
        ...t,
        availableWidth: N,
        availableHeight: R
      });
      const H = await s.getDimensions(c.floating);
      return p !== H.width || u !== H.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ve() {
  return typeof window < "u";
}
function Ce(e) {
  return Mt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Y(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function re(e) {
  var t;
  return (t = (Mt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Mt(e) {
  return Ve() ? e instanceof Node || e instanceof Y(e).Node : !1;
}
function J(e) {
  return Ve() ? e instanceof Element || e instanceof Y(e).Element : !1;
}
function oe(e) {
  return Ve() ? e instanceof HTMLElement || e instanceof Y(e).HTMLElement : !1;
}
function bt(e) {
  return !Ve() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Y(e).ShadowRoot;
}
const fo = /* @__PURE__ */ new Set(["inline", "contents"]);
function Ie(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = Q(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !fo.has(r);
}
const uo = /* @__PURE__ */ new Set(["table", "td", "th"]);
function po(e) {
  return uo.has(Ce(e));
}
const mo = [":popover-open", ":modal"];
function He(e) {
  return mo.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const ho = ["transform", "translate", "scale", "rotate", "perspective"], go = ["transform", "translate", "scale", "rotate", "perspective", "filter"], xo = ["paint", "layout", "strict", "content"];
function at(e) {
  const t = dt(), n = J(e) ? Q(e) : e;
  return ho.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || go.some((o) => (n.willChange || "").includes(o)) || xo.some((o) => (n.contain || "").includes(o));
}
function wo(e) {
  let t = ae(e);
  for (; oe(t) && !Se(t); ) {
    if (at(t))
      return t;
    if (He(t))
      return null;
    t = ae(t);
  }
  return null;
}
function dt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const vo = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Se(e) {
  return vo.has(Ce(e));
}
function Q(e) {
  return Y(e).getComputedStyle(e);
}
function Be(e) {
  return J(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ae(e) {
  if (Ce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    bt(e) && e.host || // Fallback.
    re(e)
  );
  return bt(t) ? t.host : t;
}
function Dt(e) {
  const t = ae(e);
  return Se(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : oe(t) && Ie(t) ? t : Dt(t);
}
function Oe(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Dt(e), i = r === ((o = e.ownerDocument) == null ? void 0 : o.body), s = Y(r);
  if (i) {
    const c = Je(s);
    return t.concat(s, s.visualViewport || [], Ie(r) ? r : [], c && n ? Oe(c) : []);
  }
  return t.concat(r, Oe(r, [], n));
}
function Je(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function jt(e) {
  const t = Q(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = oe(e), i = r ? e.offsetWidth : n, s = r ? e.offsetHeight : o, c = Me(n) !== i || Me(o) !== s;
  return c && (n = i, o = s), {
    width: n,
    height: o,
    $: c
  };
}
function ft(e) {
  return J(e) ? e : e.contextElement;
}
function ve(e) {
  const t = ft(e);
  if (!oe(t))
    return te(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = jt(t);
  let s = (i ? Me(n.width) : n.width) / o, c = (i ? Me(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const yo = /* @__PURE__ */ te(0);
function Lt(e) {
  const t = Y(e);
  return !dt() || !t.visualViewport ? yo : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function So(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Y(e) ? !1 : t;
}
function he(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = ft(e);
  let s = te(1);
  t && (o ? J(o) && (s = ve(o)) : s = ve(e));
  const c = So(i, n, o) ? Lt(i) : te(0);
  let l = (r.left + c.x) / s.x, d = (r.top + c.y) / s.y, a = r.width / s.x, f = r.height / s.y;
  if (i) {
    const g = Y(i), m = o && J(o) ? Y(o) : o;
    let p = g, u = Je(p);
    for (; u && o && m !== p; ) {
      const x = ve(u), y = u.getBoundingClientRect(), v = Q(u), S = y.left + (u.clientLeft + parseFloat(v.paddingLeft)) * x.x, C = y.top + (u.clientTop + parseFloat(v.paddingTop)) * x.y;
      l *= x.x, d *= x.y, a *= x.x, f *= x.y, l += S, d += C, p = Y(u), u = Je(p);
    }
  }
  return je({
    width: a,
    height: f,
    x: l,
    y: d
  });
}
function Fe(e, t) {
  const n = Be(e).scrollLeft;
  return t ? t.left + n : he(re(e)).left + n;
}
function kt(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - Fe(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function bo(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const i = r === "fixed", s = re(o), c = t ? He(t.floating) : !1;
  if (o === s || c && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = te(1);
  const a = te(0), f = oe(o);
  if ((f || !f && !i) && ((Ce(o) !== "body" || Ie(s)) && (l = Be(o)), oe(o))) {
    const m = he(o);
    d = ve(o), a.x = m.x + o.clientLeft, a.y = m.y + o.clientTop;
  }
  const g = s && !f && !i ? kt(s, l) : te(0);
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - l.scrollLeft * d.x + a.x + g.x,
    y: n.y * d.y - l.scrollTop * d.y + a.y + g.y
  };
}
function Co(e) {
  return Array.from(e.getClientRects());
}
function Po(e) {
  const t = re(e), n = Be(e), o = e.ownerDocument.body, r = q(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), i = q(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Fe(e);
  const c = -n.scrollTop;
  return Q(o).direction === "rtl" && (s += q(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: c
  };
}
const Ct = 25;
function Ao(e, t) {
  const n = Y(e), o = re(e), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, c = 0, l = 0;
  if (r) {
    i = r.width, s = r.height;
    const a = dt();
    (!a || a && t === "fixed") && (c = r.offsetLeft, l = r.offsetTop);
  }
  const d = Fe(o);
  if (d <= 0) {
    const a = o.ownerDocument, f = a.body, g = getComputedStyle(f), m = a.compatMode === "CSS1Compat" && parseFloat(g.marginLeft) + parseFloat(g.marginRight) || 0, p = Math.abs(o.clientWidth - f.clientWidth - m);
    p <= Ct && (i -= p);
  } else d <= Ct && (i += d);
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
const Ro = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function To(e, t) {
  const n = he(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, i = oe(e) ? ve(e) : te(1), s = e.clientWidth * i.x, c = e.clientHeight * i.y, l = r * i.x, d = o * i.y;
  return {
    width: s,
    height: c,
    x: l,
    y: d
  };
}
function Pt(e, t, n) {
  let o;
  if (t === "viewport")
    o = Ao(e, n);
  else if (t === "document")
    o = Po(re(e));
  else if (J(t))
    o = To(t, n);
  else {
    const r = Lt(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return je(o);
}
function Vt(e, t) {
  const n = ae(e);
  return n === t || !J(n) || Se(n) ? !1 : Q(n).position === "fixed" || Vt(n, t);
}
function Eo(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Oe(e, [], !1).filter((c) => J(c) && Ce(c) !== "body"), r = null;
  const i = Q(e).position === "fixed";
  let s = i ? ae(e) : e;
  for (; J(s) && !Se(s); ) {
    const c = Q(s), l = at(s);
    !l && c.position === "fixed" && (r = null), (i ? !l && !r : !l && c.position === "static" && !!r && Ro.has(r.position) || Ie(s) && !l && Vt(e, s)) ? o = o.filter((a) => a !== s) : r = c, s = ae(s);
  }
  return t.set(e, o), o;
}
function Oo(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const s = [...n === "clippingAncestors" ? He(t) ? [] : Eo(t, this._c) : [].concat(n), o], c = s[0], l = s.reduce((d, a) => {
    const f = Pt(t, a, r);
    return d.top = q(f.top, d.top), d.right = le(f.right, d.right), d.bottom = le(f.bottom, d.bottom), d.left = q(f.left, d.left), d;
  }, Pt(t, c, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Io(e) {
  const {
    width: t,
    height: n
  } = jt(e);
  return {
    width: t,
    height: n
  };
}
function No(e, t, n) {
  const o = oe(t), r = re(t), i = n === "fixed", s = he(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = te(0);
  function d() {
    l.x = Fe(r);
  }
  if (o || !o && !i)
    if ((Ce(t) !== "body" || Ie(r)) && (c = Be(t)), o) {
      const m = he(t, !0, i, t);
      l.x = m.x + t.clientLeft, l.y = m.y + t.clientTop;
    } else r && d();
  i && !o && r && d();
  const a = r && !o && !i ? kt(r, c) : te(0), f = s.left + c.scrollLeft - l.x - a.x, g = s.top + c.scrollTop - l.y - a.y;
  return {
    x: f,
    y: g,
    width: s.width,
    height: s.height
  };
}
function Ye(e) {
  return Q(e).position === "static";
}
function At(e, t) {
  if (!oe(e) || Q(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return re(e) === n && (n = n.ownerDocument.body), n;
}
function Ht(e, t) {
  const n = Y(e);
  if (He(e))
    return n;
  if (!oe(e)) {
    let r = ae(e);
    for (; r && !Se(r); ) {
      if (J(r) && !Ye(r))
        return r;
      r = ae(r);
    }
    return n;
  }
  let o = At(e, t);
  for (; o && po(o) && Ye(o); )
    o = At(o, t);
  return o && Se(o) && Ye(o) && !at(o) ? n : o || wo(e) || n;
}
const _o = async function(e) {
  const t = this.getOffsetParent || Ht, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: No(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Mo(e) {
  return Q(e).direction === "rtl";
}
const Do = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bo,
  getDocumentElement: re,
  getClippingRect: Oo,
  getOffsetParent: Ht,
  getElementRects: _o,
  getClientRects: Co,
  getDimensions: Io,
  getScale: ve,
  isElement: J,
  isRTL: Mo
};
function Bt(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function jo(e, t) {
  let n = null, o;
  const r = re(e);
  function i() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, l) {
    c === void 0 && (c = !1), l === void 0 && (l = 1), i();
    const d = e.getBoundingClientRect(), {
      left: a,
      top: f,
      width: g,
      height: m
    } = d;
    if (c || t(), !g || !m)
      return;
    const p = Ne(f), u = Ne(r.clientWidth - (a + g)), x = Ne(r.clientHeight - (f + m)), y = Ne(a), S = {
      rootMargin: -p + "px " + -u + "px " + -x + "px " + -y + "px",
      threshold: q(0, le(1, l)) || 1
    };
    let C = !0;
    function b(O) {
      const R = O[0].intersectionRatio;
      if (R !== l) {
        if (!C)
          return s();
        R ? s(!1, R) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      R === 1 && !Bt(d, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...S,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, S);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Lo(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, d = ft(e), a = r || i ? [...d ? Oe(d) : [], ...Oe(t)] : [];
  a.forEach((y) => {
    r && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const f = d && c ? jo(d, n) : null;
  let g = -1, m = null;
  s && (m = new ResizeObserver((y) => {
    let [v] = y;
    v && v.target === d && m && (m.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), n();
  }), d && !l && m.observe(d), m.observe(t));
  let p, u = l ? he(e) : null;
  l && x();
  function x() {
    const y = he(e);
    u && !Bt(u, y) && n(), u = y, p = requestAnimationFrame(x);
  }
  return n(), () => {
    var y;
    a.forEach((v) => {
      r && v.removeEventListener("scroll", n), i && v.removeEventListener("resize", n);
    }), f?.(), (y = m) == null || y.disconnect(), m = null, l && cancelAnimationFrame(p);
  };
}
const ko = io, Vo = co, Ho = oo, Bo = ao, Fo = ro, Rt = no, Wo = lo, $o = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Do,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return to(e, t, {
    ...r,
    platform: i
  });
};
var zo = typeof document < "u", Uo = function() {
}, _e = zo ? h.useLayoutEffect : Uo;
function Le(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Le(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && e.$$typeof) && !Le(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ft(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Tt(e, t) {
  const n = Ft(e);
  return Math.round(t * n) / n;
}
function Xe(e) {
  const t = h.useRef(e);
  return _e(() => {
    t.current = e;
  }), t;
}
function Ko(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: l,
    open: d
  } = e, [a, f] = h.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, m] = h.useState(o);
  Le(g, o) || m(o);
  const [p, u] = h.useState(null), [x, y] = h.useState(null), v = h.useCallback((A) => {
    A !== O.current && (O.current = A, u(A));
  }, []), S = h.useCallback((A) => {
    A !== R.current && (R.current = A, y(A));
  }, []), C = i || p, b = s || x, O = h.useRef(null), R = h.useRef(null), N = h.useRef(a), H = l != null, M = Xe(l), D = Xe(r), j = Xe(d), _ = h.useCallback(() => {
    if (!O.current || !R.current)
      return;
    const A = {
      placement: t,
      strategy: n,
      middleware: g
    };
    D.current && (A.platform = D.current), $o(O.current, R.current, A).then((L) => {
      const K = {
        ...L,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: j.current !== !1
      };
      E.current && !Le(N.current, K) && (N.current = K, rt.flushSync(() => {
        f(K);
      }));
    });
  }, [g, t, n, D, j]);
  _e(() => {
    d === !1 && N.current.isPositioned && (N.current.isPositioned = !1, f((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [d]);
  const E = h.useRef(!1);
  _e(() => (E.current = !0, () => {
    E.current = !1;
  }), []), _e(() => {
    if (C && (O.current = C), b && (R.current = b), C && b) {
      if (M.current)
        return M.current(C, b, _);
      _();
    }
  }, [C, b, _, M, H]);
  const B = h.useMemo(() => ({
    reference: O,
    floating: R,
    setReference: v,
    setFloating: S
  }), [v, S]), T = h.useMemo(() => ({
    reference: C,
    floating: b
  }), [C, b]), I = h.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!T.floating)
      return A;
    const L = Tt(T.floating, a.x), K = Tt(T.floating, a.y);
    return c ? {
      ...A,
      transform: "translate(" + L + "px, " + K + "px)",
      ...Ft(T.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: L,
      top: K
    };
  }, [n, c, T.floating, a.x, a.y]);
  return h.useMemo(() => ({
    ...a,
    update: _,
    refs: B,
    elements: T,
    floatingStyles: I
  }), [a, _, B, T, I]);
}
const qo = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Rt({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Rt({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, Yo = (e, t) => ({
  ...ko(e),
  options: [e, t]
}), Xo = (e, t) => ({
  ...Vo(e),
  options: [e, t]
}), Go = (e, t) => ({
  ...Wo(e),
  options: [e, t]
}), Zo = (e, t) => ({
  ...Ho(e),
  options: [e, t]
}), Jo = (e, t) => ({
  ...Bo(e),
  options: [e, t]
}), Qo = (e, t) => ({
  ...Fo(e),
  options: [e, t]
}), er = (e, t) => ({
  ...qo(e),
  options: [e, t]
});
var tr = "Arrow", Wt = h.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...i } = e;
  return /* @__PURE__ */ w.jsx(
    z.svg,
    {
      ...i,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ w.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Wt.displayName = tr;
var nr = Wt, ut = "Popper", [$t, zt] = Et(ut), [or, Ut] = $t(ut), Kt = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = h.useState(null);
  return /* @__PURE__ */ w.jsx(or, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Kt.displayName = ut;
var qt = "PopperAnchor", Yt = h.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, i = Ut(qt, n), s = h.useRef(null), c = G(t, s), l = h.useRef(null);
    return h.useEffect(() => {
      const d = l.current;
      l.current = o?.current || s.current, d !== l.current && i.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ w.jsx(z.div, { ...r, ref: c });
  }
);
Yt.displayName = qt;
var pt = "PopperContent", [rr, sr] = $t(pt), Xt = h.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: l = !0,
      collisionBoundary: d = [],
      collisionPadding: a = 0,
      sticky: f = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: p,
      ...u
    } = e, x = Ut(pt, n), [y, v] = h.useState(null), S = G(t, (P) => v(P)), [C, b] = h.useState(null), O = Tn(C), R = O?.width ?? 0, N = O?.height ?? 0, H = o + (i !== "center" ? "-" + i : ""), M = typeof a == "number" ? a : { top: 0, right: 0, bottom: 0, left: 0, ...a }, D = Array.isArray(d) ? d : [d], j = D.length > 0, _ = {
      padding: M,
      boundary: D.filter(cr),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: j
    }, { refs: E, floatingStyles: B, placement: T, isPositioned: I, middlewareData: A } = Ko({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: H,
      whileElementsMounted: (...P) => Lo(...P, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: x.anchor
      },
      middleware: [
        Yo({ mainAxis: r + N, alignmentAxis: s }),
        l && Xo({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Go() : void 0,
          ..._
        }),
        l && Zo({ ..._ }),
        Jo({
          ..._,
          apply: ({ elements: P, rects: F, availableWidth: U, availableHeight: k }) => {
            const { width: V, height: W } = F.reference, X = P.floating.style;
            X.setProperty("--radix-popper-available-width", `${U}px`), X.setProperty("--radix-popper-available-height", `${k}px`), X.setProperty("--radix-popper-anchor-width", `${V}px`), X.setProperty("--radix-popper-anchor-height", `${W}px`);
          }
        }),
        C && er({ element: C, padding: c }),
        lr({ arrowWidth: R, arrowHeight: N }),
        g && Qo({ strategy: "referenceHidden", ..._ })
      ]
    }), [L, K] = Jt(T), ue = Ot(p);
    ne(() => {
      I && ue?.();
    }, [I, ue]);
    const Ae = A.arrow?.x, Re = A.arrow?.y, ce = A.arrow?.centerOffset !== 0, [we, pe] = h.useState();
    return ne(() => {
      y && pe(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ w.jsx(
      "div",
      {
        ref: E.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...B,
          transform: I ? B.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: we,
          "--radix-popper-transform-origin": [
            A.transformOrigin?.x,
            A.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...A.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ w.jsx(
          rr,
          {
            scope: n,
            placedSide: L,
            onArrowChange: b,
            arrowX: Ae,
            arrowY: Re,
            shouldHideArrow: ce,
            children: /* @__PURE__ */ w.jsx(
              z.div,
              {
                "data-side": L,
                "data-align": K,
                ...u,
                ref: S,
                style: {
                  ...u.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: I ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Xt.displayName = pt;
var Gt = "PopperArrow", ir = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Zt = h.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, i = sr(Gt, o), s = ir[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ w.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ w.jsx(
          nr,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Zt.displayName = Gt;
function cr(e) {
  return e !== null;
}
var lr = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: o, middlewareData: r } = t, s = r.arrow?.centerOffset !== 0, c = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [d, a] = Jt(n), f = { start: "0%", center: "50%", end: "100%" }[a], g = (r.arrow?.x ?? 0) + c / 2, m = (r.arrow?.y ?? 0) + l / 2;
    let p = "", u = "";
    return d === "bottom" ? (p = s ? f : `${g}px`, u = `${-l}px`) : d === "top" ? (p = s ? f : `${g}px`, u = `${o.floating.height + l}px`) : d === "right" ? (p = `${-l}px`, u = s ? f : `${m}px`) : d === "left" && (p = `${o.floating.width + l}px`, u = s ? f : `${m}px`), { data: { x: p, y: u } };
  }
});
function Jt(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var ar = Kt, dr = Yt, fr = Xt, ur = Zt, Qt = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), pr = "VisuallyHidden", mr = h.forwardRef(
  (e, t) => /* @__PURE__ */ w.jsx(
    z.span,
    {
      ...e,
      ref: t,
      style: { ...Qt, ...e.style }
    }
  )
);
mr.displayName = pr;
var hr = [" ", "Enter", "ArrowUp", "ArrowDown"], gr = [" ", "Enter"], ge = "Select", [We, $e, xr] = On(ge), [Pe] = Et(ge, [
  xr,
  zt
]), ze = zt(), [wr, de] = Pe(ge), [vr, yr] = Pe(ge), en = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: i,
    value: s,
    defaultValue: c,
    onValueChange: l,
    dir: d,
    name: a,
    autoComplete: f,
    disabled: g,
    required: m,
    form: p
  } = e, u = ze(t), [x, y] = h.useState(null), [v, S] = h.useState(null), [C, b] = h.useState(!1), O = En(d), [R, N] = ht({
    prop: o,
    defaultProp: r ?? !1,
    onChange: i,
    caller: ge
  }), [H, M] = ht({
    prop: s,
    defaultProp: c,
    onChange: l,
    caller: ge
  }), D = h.useRef(null), j = x ? p || !!x.closest("form") : !0, [_, E] = h.useState(/* @__PURE__ */ new Set()), B = Array.from(_).map((T) => T.props.value).join(";");
  return /* @__PURE__ */ w.jsx(ar, { ...u, children: /* @__PURE__ */ w.jsxs(
    wr,
    {
      required: m,
      scope: t,
      trigger: x,
      onTriggerChange: y,
      valueNode: v,
      onValueNodeChange: S,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: b,
      contentId: st(),
      value: H,
      onValueChange: M,
      open: R,
      onOpenChange: N,
      dir: O,
      triggerPointerDownPosRef: D,
      disabled: g,
      children: [
        /* @__PURE__ */ w.jsx(We.Provider, { scope: t, children: /* @__PURE__ */ w.jsx(
          vr,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: h.useCallback((T) => {
              E((I) => new Set(I).add(T));
            }, []),
            onNativeOptionRemove: h.useCallback((T) => {
              E((I) => {
                const A = new Set(I);
                return A.delete(T), A;
              });
            }, []),
            children: n
          }
        ) }),
        j ? /* @__PURE__ */ w.jsxs(
          bn,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: a,
            autoComplete: f,
            value: H,
            onChange: (T) => M(T.target.value),
            disabled: g,
            form: p,
            children: [
              H === void 0 ? /* @__PURE__ */ w.jsx("option", { value: "" }) : null,
              Array.from(_)
            ]
          },
          B
        ) : null
      ]
    }
  ) });
};
en.displayName = ge;
var tn = "SelectTrigger", nn = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, i = ze(n), s = de(tn, n), c = s.disabled || o, l = G(t, s.onTriggerChange), d = $e(n), a = h.useRef("touch"), [f, g, m] = Pn((u) => {
      const x = d().filter((S) => !S.disabled), y = x.find((S) => S.value === s.value), v = An(x, u, y);
      v !== void 0 && s.onValueChange(v.value);
    }), p = (u) => {
      c || (s.onOpenChange(!0), m()), u && (s.triggerPointerDownPosRef.current = {
        x: Math.round(u.pageX),
        y: Math.round(u.pageY)
      });
    };
    return /* @__PURE__ */ w.jsx(dr, { asChild: !0, ...i, children: /* @__PURE__ */ w.jsx(
      z.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: c,
        "data-disabled": c ? "" : void 0,
        "data-placeholder": Cn(s.value) ? "" : void 0,
        ...r,
        ref: l,
        onClick: $(r.onClick, (u) => {
          u.currentTarget.focus(), a.current !== "mouse" && p(u);
        }),
        onPointerDown: $(r.onPointerDown, (u) => {
          a.current = u.pointerType;
          const x = u.target;
          x.hasPointerCapture(u.pointerId) && x.releasePointerCapture(u.pointerId), u.button === 0 && u.ctrlKey === !1 && u.pointerType === "mouse" && (p(u), u.preventDefault());
        }),
        onKeyDown: $(r.onKeyDown, (u) => {
          const x = f.current !== "";
          !(u.ctrlKey || u.altKey || u.metaKey) && u.key.length === 1 && g(u.key), !(x && u.key === " ") && hr.includes(u.key) && (p(), u.preventDefault());
        })
      }
    ) });
  }
);
nn.displayName = tn;
var on = "SelectValue", Sr = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: i, placeholder: s = "", ...c } = e, l = de(on, n), { onValueNodeHasChildrenChange: d } = l, a = i !== void 0, f = G(t, l.onValueNodeChange);
    return ne(() => {
      d(a);
    }, [d, a]), /* @__PURE__ */ w.jsx(
      z.span,
      {
        ...c,
        ref: f,
        style: { pointerEvents: "none" },
        children: Cn(l.value) ? /* @__PURE__ */ w.jsx(w.Fragment, { children: s }) : i
      }
    );
  }
);
Sr.displayName = on;
var br = "SelectIcon", rn = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ w.jsx(z.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
rn.displayName = br;
var Cr = "SelectPortal", sn = (e) => /* @__PURE__ */ w.jsx(In, { asChild: !0, ...e });
sn.displayName = Cr;
var xe = "SelectContent", cn = h.forwardRef(
  (e, t) => {
    const n = de(xe, e.__scopeSelect), [o, r] = h.useState();
    if (ne(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const i = o;
      return i ? rt.createPortal(
        /* @__PURE__ */ w.jsx(ln, { scope: e.__scopeSelect, children: /* @__PURE__ */ w.jsx(We.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ w.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ w.jsx(an, { ...e, ref: t });
  }
);
cn.displayName = xe;
var Z = 10, [ln, fe] = Pe(xe), Pr = "SelectContentImpl", Ar = Bn("SelectContent.RemoveScroll"), an = h.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: c,
      sideOffset: l,
      align: d,
      alignOffset: a,
      arrowPadding: f,
      collisionBoundary: g,
      collisionPadding: m,
      sticky: p,
      hideWhenDetached: u,
      avoidCollisions: x,
      //
      ...y
    } = e, v = de(xe, n), [S, C] = h.useState(null), [b, O] = h.useState(null), R = G(t, (P) => C(P)), [N, H] = h.useState(null), [M, D] = h.useState(
      null
    ), j = $e(n), [_, E] = h.useState(!1), B = h.useRef(!1);
    h.useEffect(() => {
      if (S) return _n(S);
    }, [S]), Mn();
    const T = h.useCallback(
      (P) => {
        const [F, ...U] = j().map((W) => W.ref.current), [k] = U.slice(-1), V = document.activeElement;
        for (const W of P)
          if (W === V || (W?.scrollIntoView({ block: "nearest" }), W === F && b && (b.scrollTop = 0), W === k && b && (b.scrollTop = b.scrollHeight), W?.focus(), document.activeElement !== V)) return;
      },
      [j, b]
    ), I = h.useCallback(
      () => T([N, S]),
      [T, N, S]
    );
    h.useEffect(() => {
      _ && I();
    }, [_, I]);
    const { onOpenChange: A, triggerPointerDownPosRef: L } = v;
    h.useEffect(() => {
      if (S) {
        let P = { x: 0, y: 0 };
        const F = (k) => {
          P = {
            x: Math.abs(Math.round(k.pageX) - (L.current?.x ?? 0)),
            y: Math.abs(Math.round(k.pageY) - (L.current?.y ?? 0))
          };
        }, U = (k) => {
          P.x <= 10 && P.y <= 10 ? k.preventDefault() : S.contains(k.target) || A(!1), document.removeEventListener("pointermove", F), L.current = null;
        };
        return L.current !== null && (document.addEventListener("pointermove", F), document.addEventListener("pointerup", U, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", F), document.removeEventListener("pointerup", U, { capture: !0 });
        };
      }
    }, [S, A, L]), h.useEffect(() => {
      const P = () => A(!1);
      return window.addEventListener("blur", P), window.addEventListener("resize", P), () => {
        window.removeEventListener("blur", P), window.removeEventListener("resize", P);
      };
    }, [A]);
    const [K, ue] = Pn((P) => {
      const F = j().filter((V) => !V.disabled), U = F.find((V) => V.ref.current === document.activeElement), k = An(F, P, U);
      k && setTimeout(() => k.ref.current.focus());
    }), Ae = h.useCallback(
      (P, F, U) => {
        const k = !B.current && !U;
        (v.value !== void 0 && v.value === F || k) && (H(P), k && (B.current = !0));
      },
      [v.value]
    ), Re = h.useCallback(() => S?.focus(), [S]), ce = h.useCallback(
      (P, F, U) => {
        const k = !B.current && !U;
        (v.value !== void 0 && v.value === F || k) && D(P);
      },
      [v.value]
    ), we = o === "popper" ? Qe : dn, pe = we === Qe ? {
      side: c,
      sideOffset: l,
      align: d,
      alignOffset: a,
      arrowPadding: f,
      collisionBoundary: g,
      collisionPadding: m,
      sticky: p,
      hideWhenDetached: u,
      avoidCollisions: x
    } : {};
    return /* @__PURE__ */ w.jsx(
      ln,
      {
        scope: n,
        content: S,
        viewport: b,
        onViewportChange: O,
        itemRefCallback: Ae,
        selectedItem: N,
        onItemLeave: Re,
        itemTextRefCallback: ce,
        focusSelectedItem: I,
        selectedItemText: M,
        position: o,
        isPositioned: _,
        searchRef: K,
        children: /* @__PURE__ */ w.jsx(Dn, { as: Ar, allowPinchZoom: !0, children: /* @__PURE__ */ w.jsx(
          jn,
          {
            asChild: !0,
            trapped: v.open,
            onMountAutoFocus: (P) => {
              P.preventDefault();
            },
            onUnmountAutoFocus: $(r, (P) => {
              v.trigger?.focus({ preventScroll: !0 }), P.preventDefault();
            }),
            children: /* @__PURE__ */ w.jsx(
              Ln,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: s,
                onFocusOutside: (P) => P.preventDefault(),
                onDismiss: () => v.onOpenChange(!1),
                children: /* @__PURE__ */ w.jsx(
                  we,
                  {
                    role: "listbox",
                    id: v.contentId,
                    "data-state": v.open ? "open" : "closed",
                    dir: v.dir,
                    onContextMenu: (P) => P.preventDefault(),
                    ...y,
                    ...pe,
                    onPlaced: () => E(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: $(y.onKeyDown, (P) => {
                      const F = P.ctrlKey || P.altKey || P.metaKey;
                      if (P.key === "Tab" && P.preventDefault(), !F && P.key.length === 1 && ue(P.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(P.key)) {
                        let k = j().filter((V) => !V.disabled).map((V) => V.ref.current);
                        if (["ArrowUp", "End"].includes(P.key) && (k = k.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(P.key)) {
                          const V = P.target, W = k.indexOf(V);
                          k = k.slice(W + 1);
                        }
                        setTimeout(() => T(k)), P.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
an.displayName = Pr;
var Rr = "SelectItemAlignedPosition", dn = h.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, i = de(xe, n), s = fe(xe, n), [c, l] = h.useState(null), [d, a] = h.useState(null), f = G(t, (R) => a(R)), g = $e(n), m = h.useRef(!1), p = h.useRef(!0), { viewport: u, selectedItem: x, selectedItemText: y, focusSelectedItem: v } = s, S = h.useCallback(() => {
    if (i.trigger && i.valueNode && c && d && u && x && y) {
      const R = i.trigger.getBoundingClientRect(), N = d.getBoundingClientRect(), H = i.valueNode.getBoundingClientRect(), M = y.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const V = M.left - N.left, W = H.left - V, X = R.left - W, me = R.width + X, Ue = Math.max(me, N.width), Ke = window.innerWidth - Z, qe = gt(W, [
          Z,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Z, Ke - Ue)
        ]);
        c.style.minWidth = me + "px", c.style.left = qe + "px";
      } else {
        const V = N.right - M.right, W = window.innerWidth - H.right - V, X = window.innerWidth - R.right - W, me = R.width + X, Ue = Math.max(me, N.width), Ke = window.innerWidth - Z, qe = gt(W, [
          Z,
          Math.max(Z, Ke - Ue)
        ]);
        c.style.minWidth = me + "px", c.style.right = qe + "px";
      }
      const D = g(), j = window.innerHeight - Z * 2, _ = u.scrollHeight, E = window.getComputedStyle(d), B = parseInt(E.borderTopWidth, 10), T = parseInt(E.paddingTop, 10), I = parseInt(E.borderBottomWidth, 10), A = parseInt(E.paddingBottom, 10), L = B + T + _ + A + I, K = Math.min(x.offsetHeight * 5, L), ue = window.getComputedStyle(u), Ae = parseInt(ue.paddingTop, 10), Re = parseInt(ue.paddingBottom, 10), ce = R.top + R.height / 2 - Z, we = j - ce, pe = x.offsetHeight / 2, P = x.offsetTop + pe, F = B + T + P, U = L - F;
      if (F <= ce) {
        const V = D.length > 0 && x === D[D.length - 1].ref.current;
        c.style.bottom = "0px";
        const W = d.clientHeight - u.offsetTop - u.offsetHeight, X = Math.max(
          we,
          pe + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (V ? Re : 0) + W + I
        ), me = F + X;
        c.style.height = me + "px";
      } else {
        const V = D.length > 0 && x === D[0].ref.current;
        c.style.top = "0px";
        const X = Math.max(
          ce,
          B + u.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (V ? Ae : 0) + pe
        ) + U;
        c.style.height = X + "px", u.scrollTop = F - ce + u.offsetTop;
      }
      c.style.margin = `${Z}px 0`, c.style.minHeight = K + "px", c.style.maxHeight = j + "px", o?.(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    g,
    i.trigger,
    i.valueNode,
    c,
    d,
    u,
    x,
    y,
    i.dir,
    o
  ]);
  ne(() => S(), [S]);
  const [C, b] = h.useState();
  ne(() => {
    d && b(window.getComputedStyle(d).zIndex);
  }, [d]);
  const O = h.useCallback(
    (R) => {
      R && p.current === !0 && (S(), v?.(), p.current = !1);
    },
    [S, v]
  );
  return /* @__PURE__ */ w.jsx(
    Er,
    {
      scope: n,
      contentWrapper: c,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: O,
      children: /* @__PURE__ */ w.jsx(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ w.jsx(
            z.div,
            {
              ...r,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
dn.displayName = Rr;
var Tr = "SelectPopperPosition", Qe = h.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = Z,
    ...i
  } = e, s = ze(n);
  return /* @__PURE__ */ w.jsx(
    fr,
    {
      ...s,
      ...i,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Qe.displayName = Tr;
var [Er, mt] = Pe(xe, {}), et = "SelectViewport", fn = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, i = fe(et, n), s = mt(et, n), c = G(t, i.onViewportChange), l = h.useRef(0);
    return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
      /* @__PURE__ */ w.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ w.jsx(We.Slot, { scope: n, children: /* @__PURE__ */ w.jsx(
        z.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: c,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: $(r.onScroll, (d) => {
            const a = d.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: g } = s;
            if (g?.current && f) {
              const m = Math.abs(l.current - a.scrollTop);
              if (m > 0) {
                const p = window.innerHeight - Z * 2, u = parseFloat(f.style.minHeight), x = parseFloat(f.style.height), y = Math.max(u, x);
                if (y < p) {
                  const v = y + m, S = Math.min(p, v), C = v - S;
                  f.style.height = S + "px", f.style.bottom === "0px" && (a.scrollTop = C > 0 ? C : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = a.scrollTop;
          })
        }
      ) })
    ] });
  }
);
fn.displayName = et;
var un = "SelectGroup", [Or, Ir] = Pe(un), Nr = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = st();
    return /* @__PURE__ */ w.jsx(Or, { scope: n, id: r, children: /* @__PURE__ */ w.jsx(z.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
Nr.displayName = un;
var pn = "SelectLabel", _r = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Ir(pn, n);
    return /* @__PURE__ */ w.jsx(z.div, { id: r.id, ...o, ref: t });
  }
);
_r.displayName = pn;
var ke = "SelectItem", [Mr, mn] = Pe(ke), hn = h.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: i,
      ...s
    } = e, c = de(ke, n), l = fe(ke, n), d = c.value === o, [a, f] = h.useState(i ?? ""), [g, m] = h.useState(!1), p = G(
      t,
      (v) => l.itemRefCallback?.(v, o, r)
    ), u = st(), x = h.useRef("touch"), y = () => {
      r || (c.onValueChange(o), c.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ w.jsx(
      Mr,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: u,
        isSelected: d,
        onItemTextChange: h.useCallback((v) => {
          f((S) => S || (v?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ w.jsx(
          We.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: a,
            children: /* @__PURE__ */ w.jsx(
              z.div,
              {
                role: "option",
                "aria-labelledby": u,
                "data-highlighted": g ? "" : void 0,
                "aria-selected": d && g,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...s,
                ref: p,
                onFocus: $(s.onFocus, () => m(!0)),
                onBlur: $(s.onBlur, () => m(!1)),
                onClick: $(s.onClick, () => {
                  x.current !== "mouse" && y();
                }),
                onPointerUp: $(s.onPointerUp, () => {
                  x.current === "mouse" && y();
                }),
                onPointerDown: $(s.onPointerDown, (v) => {
                  x.current = v.pointerType;
                }),
                onPointerMove: $(s.onPointerMove, (v) => {
                  x.current = v.pointerType, r ? l.onItemLeave?.() : x.current === "mouse" && v.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: $(s.onPointerLeave, (v) => {
                  v.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: $(s.onKeyDown, (v) => {
                  l.searchRef?.current !== "" && v.key === " " || (gr.includes(v.key) && y(), v.key === " " && v.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
hn.displayName = ke;
var Te = "SelectItemText", gn = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...i } = e, s = de(Te, n), c = fe(Te, n), l = mn(Te, n), d = yr(Te, n), [a, f] = h.useState(null), g = G(
      t,
      (y) => f(y),
      l.onItemTextChange,
      (y) => c.itemTextRefCallback?.(y, l.value, l.disabled)
    ), m = a?.textContent, p = h.useMemo(
      () => /* @__PURE__ */ w.jsx("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: u, onNativeOptionRemove: x } = d;
    return ne(() => (u(p), () => x(p)), [u, x, p]), /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
      /* @__PURE__ */ w.jsx(z.span, { id: l.textId, ...i, ref: g }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? rt.createPortal(i.children, s.valueNode) : null
    ] });
  }
);
gn.displayName = Te;
var xn = "SelectItemIndicator", wn = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return mn(xn, n).isSelected ? /* @__PURE__ */ w.jsx(z.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
wn.displayName = xn;
var tt = "SelectScrollUpButton", vn = h.forwardRef((e, t) => {
  const n = fe(tt, e.__scopeSelect), o = mt(tt, e.__scopeSelect), [r, i] = h.useState(!1), s = G(t, o.onScrollButtonChange);
  return ne(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const d = l.scrollTop > 0;
        i(d);
      };
      const l = n.viewport;
      return c(), l.addEventListener("scroll", c), () => l.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ w.jsx(
    Sn,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: l } = n;
        c && l && (c.scrollTop = c.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
vn.displayName = tt;
var nt = "SelectScrollDownButton", yn = h.forwardRef((e, t) => {
  const n = fe(nt, e.__scopeSelect), o = mt(nt, e.__scopeSelect), [r, i] = h.useState(!1), s = G(t, o.onScrollButtonChange);
  return ne(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const d = l.scrollHeight - l.clientHeight, a = Math.ceil(l.scrollTop) < d;
        i(a);
      };
      const l = n.viewport;
      return c(), l.addEventListener("scroll", c), () => l.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ w.jsx(
    Sn,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: l } = n;
        c && l && (c.scrollTop = c.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
yn.displayName = nt;
var Sn = h.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, i = fe("SelectScrollButton", n), s = h.useRef(null), c = $e(n), l = h.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return h.useEffect(() => () => l(), [l]), ne(() => {
    c().find((a) => a.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [c]), /* @__PURE__ */ w.jsx(
    z.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: $(r.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(o, 50));
      }),
      onPointerMove: $(r.onPointerMove, () => {
        i.onItemLeave?.(), s.current === null && (s.current = window.setInterval(o, 50));
      }),
      onPointerLeave: $(r.onPointerLeave, () => {
        l();
      })
    }
  );
}), Dr = "SelectSeparator", jr = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ w.jsx(z.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
jr.displayName = Dr;
var ot = "SelectArrow", Lr = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = ze(n), i = de(ot, n), s = fe(ot, n);
    return i.open && s.position === "popper" ? /* @__PURE__ */ w.jsx(ur, { ...r, ...o, ref: t }) : null;
  }
);
Lr.displayName = ot;
var kr = "SelectBubbleInput", bn = h.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const r = h.useRef(null), i = G(o, r), s = Nn(t);
    return h.useEffect(() => {
      const c = r.current;
      if (!c) return;
      const l = window.HTMLSelectElement.prototype, a = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== t && a) {
        const f = new Event("change", { bubbles: !0 });
        a.call(c, t), c.dispatchEvent(f);
      }
    }, [s, t]), /* @__PURE__ */ w.jsx(
      z.select,
      {
        ...n,
        style: { ...Qt, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
bn.displayName = kr;
function Cn(e) {
  return e === "" || e === void 0;
}
function Pn(e) {
  const t = Ot(e), n = h.useRef(""), o = h.useRef(0), r = h.useCallback(
    (s) => {
      const c = n.current + s;
      t(c), (function l(d) {
        n.current = d, window.clearTimeout(o.current), d !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      })(c);
    },
    [t]
  ), i = h.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return h.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, i];
}
function An(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = Vr(e, Math.max(i, 0));
  r.length === 1 && (s = s.filter((d) => d !== n));
  const l = s.find(
    (d) => d.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function Vr(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var Hr = en, Br = nn, Fr = rn, Wr = sn, $r = cn, zr = fn, Ur = hn, Kr = gn, qr = wn, Yr = vn, Xr = yn;
function Gr({
  ...e
}) {
  return /* @__PURE__ */ w.jsx(Hr, {
    "data-slot": "select",
    ...e
  });
}
function Zr({
  className: e,
  size: t = "default",
  children: n,
  ...o
}) {
  return /* @__PURE__ */ w.jsxs(Br, {
    "data-slot": "select-trigger",
    "data-size": t,
    className: ye("border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex w-fit items-center justify-between gap-2 rounded border bg-transparent p-3 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-11 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
    ...o,
    children: [n, /* @__PURE__ */ w.jsx(Fr, {
      asChild: !0,
      children: /* @__PURE__ */ w.jsx(It, {
        className: "size-4 opacity-50"
      })
    })]
  });
}
function Jr({
  className: e,
  children: t,
  position: n = "popper",
  align: o = "center",
  ...r
}) {
  return /* @__PURE__ */ w.jsx(Wr, {
    children: /* @__PURE__ */ w.jsxs($r, {
      "data-slot": "select-content",
      className: ye("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md", n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", e),
      position: n,
      align: o,
      ...r,
      children: [/* @__PURE__ */ w.jsx(es, {}), /* @__PURE__ */ w.jsx(zr, {
        className: ye("p-1", n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
        children: t
      }), /* @__PURE__ */ w.jsx(ts, {})]
    })
  });
}
function Qr({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ w.jsxs(Ur, {
    "data-slot": "select-item",
    className: ye("focus:bg-accent focus:text-accent-foreground data-[state=checked]:bg-accent data-[state=checked]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", e),
    ...n,
    children: [/* @__PURE__ */ w.jsx("span", {
      className: "absolute right-2 flex size-3.5 items-center justify-center",
      children: /* @__PURE__ */ w.jsx(qr, {
        children: /* @__PURE__ */ w.jsx(kn, {
          className: "size-4"
        })
      })
    }), /* @__PURE__ */ w.jsx(Kr, {
      children: t
    })]
  });
}
function es({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w.jsx(Yr, {
    "data-slot": "select-scroll-up-button",
    className: ye("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ w.jsx($n, {
      className: "size-4"
    })
  });
}
function ts({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w.jsx(Xr, {
    "data-slot": "select-scroll-down-button",
    className: ye("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ w.jsx(It, {
      className: "size-4"
    })
  });
}
function ns({
  products: e,
  defaultOptions: t
}) {
  const n = Array.from(new Set(e.flatMap((a) => a.options.map((f) => f.name)))).sort((a, f) => {
    const g = t?.find((p) => p.name === a)?.position ?? 999, m = t?.find((p) => p.name === f)?.position ?? 999;
    return g - m;
  }), o = e.map((a) => {
    const f = {};
    return n.forEach((g) => {
      const m = a.options.find((p) => p.name === g);
      f[g] = m?.optionValues[0]?.name || "N/A";
    }), {
      handle: a.handle,
      options: f,
      quantityAvailable: a.variants.nodes[0]?.quantityAvailable || 0
    };
  }), r = {};
  t?.forEach((a) => {
    a.values?.[0] && (r[a.name] = a.values[0]);
  }), n.forEach((a) => {
    if (!r[a]) {
      const f = new Set(o.map((g) => g.options[a]));
      f.size === 1 && (r[a] = Array.from(f)[0]);
    }
  });
  const [i, s] = h.useState(r), c = (a) => {
    const f = o.filter((p) => Object.entries(i).every(([u, x]) => u === a ? !0 : p.options[u] === x)), g = /* @__PURE__ */ new Map();
    return f.forEach((p) => {
      const u = p.options[a], x = p.quantityAvailable > 0;
      (!g.has(u) || x) && g.set(u, x || g.get(u) || !1);
    }), Array.from(g.entries()).map(([p, u]) => ({
      value: p,
      isInStock: u
    })).sort((p, u) => {
      if (p.isInStock !== u.isInStock)
        return p.isInStock ? -1 : 1;
      const x = Number(p.value.match(/^\d+/)?.[0]), y = Number(u.value.match(/^\d+/)?.[0]);
      return !isNaN(x) && !isNaN(y) ? x - y : p.value.localeCompare(u.value);
    });
  }, l = (a, f) => {
    const g = {
      ...i,
      [a]: f
    };
    return o.find((p) => Object.entries(g).every(([u, x]) => p.options[u] === x))?.handle || null;
  }, d = (a, f) => {
    const g = {
      ...i,
      [a]: f
    };
    s(g);
    const m = l(a, f);
    m && (window.location.href = `/products/${m}`);
  };
  return /* @__PURE__ */ w.jsx("div", {
    className: "flex flex-col gap-2 mb-2",
    children: n.map((a) => {
      const f = c(a), g = i[a] || f[0]?.value, m = f.find((p) => p.value === g)?.isInStock ?? !0;
      return f.length <= 1 ? null : /* @__PURE__ */ w.jsxs(Gr, {
        value: g,
        onValueChange: (p) => d(a, p),
        children: [/* @__PURE__ */ w.jsx(Zr, {
          className: "w-full text-md",
          children: /* @__PURE__ */ w.jsxs("span", {
            children: [/* @__PURE__ */ w.jsx("b", {
              children: a
            }), ": ", g, !m && /* @__PURE__ */ w.jsx("span", {
              className: "text-gray-400",
              children: " - Out of Stock"
            })]
          })
        }), /* @__PURE__ */ w.jsx(Jr, {
          className: "bg-white max-h-60",
          children: f.map(({
            value: p,
            isInStock: u
          }) => /* @__PURE__ */ w.jsxs(Qr, {
            value: p,
            children: [p, !u && /* @__PURE__ */ w.jsx("span", {
              className: "text-gray-400",
              children: " - Out of Stock"
            })]
          }, p))
        })]
      }, a);
    })
  });
}
class os extends Rn {
  async connectedCallback() {
    super.connectedCallback();
    const t = this.querySelector("[data-spinner]"), n = this.dataset.familyId;
    if (!n) {
      t && t.classList.add("hidden"), console.warn("[VariantSelector] Family ID is not found");
      return;
    }
    const o = await Vn(`#graphql
    query Products($filters: [ProductFilter!]) {
      search(query: "", types: [PRODUCT], productFilters: $filters, first: 250) {
        nodes {
            ... on Product {
                id
                handle
                title
                tags
                featuredImage {
                    url
                }
                productFamilyId: metafield(namespace: "shophouzz", key: "product_family_id") {
                    value
                }
                options(first: 50) {
                    name
                    optionValues {
                        name
                    }
                }
                variants(first: 1) {
                    nodes {
                        id
                        price {
                            amount
                        }
                        compareAtPrice {
                            amount
                        }
                        quantityAvailable
                        sku
                        selectedOptions {
                            name
                            value
                        }
                    }
                }
            }
        }
      }
    }
    `, {
      filters: [{
        productMetafield: {
          namespace: "shophouzz",
          key: "product_family_id",
          value: n
        }
      }]
    });
    if (t && t.classList.add("hidden"), !o.data?.search?.nodes?.length) {
      console.warn("[VariantSelector] No products found in the family");
      return;
    }
    const r = o.data.search.nodes, i = this.dataset.productHandle;
    if (!i || !r.length) {
      i || console.warn("[VariantSelector] Product handle is not found"), r.length || console.warn("[VariantSelector] No products found in the family"), console.warn("[VariantSelector] Product handle is not found");
      return;
    }
    const s = this.getJson("default-options");
    Hn.createRoot(this).render(/* @__PURE__ */ w.jsx(ns, {
      products: r,
      defaultOptions: s
    }));
  }
}
customElements.get("hz-variant-selector") || customElements.define("hz-variant-selector", os);
